import { useContext } from 'react';
import { ApiContext } from '../context';

export function useApi() {
  const api = useContext(ApiContext);
  if (!api) throw new Error(`useApi must be used within a ApiContextProvider`);
  return api;
}
